<ng-container *ngIf="isMobile; then mobileTemplate; else tabletDesktopTemplate"></ng-container>

<ng-template #mobileTemplate>
  <div
    *ngIf="shimanoDiscountBuckets"
    class="mobile-shimano-discount-buckets-container d-inline-block"
    display="dynamic"
    placement="bottom-left"
    ngbDropdown
  >
    <button class="btn btn-link p-0" id="discountTypeDropdown" ngbDropdownToggle>
      {{ shimanoDiscountBuckets[activeI]?.name }}
      <mat-icon class="material-icons-sharp light md-12 ml-1">expand_more</mat-icon>
    </button>
    <div ngbDropdownMenu aria-labelledby="discountTypeDropdown" class="dropdown-menu dropdown-menu-right border-0">
      <button
        ngbDropdownItem
        (click)="onClickDiscountBucket(bucket, i); activeI = i"
        *ngFor="let bucket of shimanoDiscountBuckets; let i = index"
        [class.selected]="activeI === i"
      >
        <mat-icon svgIcon="check" class="md-12 mr-1" *ngIf="activeI === i"></mat-icon> {{ bucket?.name }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #tabletDesktopTemplate>
  <div class="shimano-discount-buckets-container" *ngIf="discountType$ | async">
    <mat-nav-list *ngIf="shimanoDiscountBuckets">
      <a
        mat-list-item
        disableRipple
        *ngFor="let bucket of shimanoDiscountBuckets; let i = index"
        [class.selected]="discountBucketActive === bucket.code"
        (click)="onClickDiscountBucket(bucket, i); activeI = i"
      >
        {{ bucket?.name }}
      </a>
    </mat-nav-list>
  </div>
</ng-template>
